module.exports = __webpack_public_path__ + "img/back-button.eacad8a1.svg";